module.exports = __webpack_public_path__ + "images/category_lp/trading_card/store_images/1@2x_30c9d1b01ca4ff5cccdfb07f9ea3934a.png";